// All monetary values are stored and transported as integer minor units (e.g. euro cents).

const formatters = new Map<string, Intl.NumberFormat>();

export function formatMoney(minor: number, currency = 'EUR', locale = 'en-GB'): string {
  const key = `${currency}:${locale}`;
  let f = formatters.get(key);
  if (!f) {
    // narrowSymbol gives "12,50 $" rather than "12,50 USD" when a currency has a local symbol.
    f = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2 });
    formatters.set(key, f);
  }
  const value = f.format(minor / 100);
  // Drop ".00" (",00" in Lithuanian) for a cleaner look on whole amounts.
  return value.replace(/[.,]00(?=\D*$)/, '');
}

/** "12.5" -> 1250. Returns NaN for invalid input. */
export function toMinor(major: string | number): number {
  if (typeof major === 'number') return Math.round(major * 100);
  const cleaned = major.replace(/[^0-9.\-]/g, '');
  if (!cleaned || !/^-?\d*(\.\d{0,2})?$/.test(cleaned)) return Number.NaN;
  return Math.round(Number.parseFloat(cleaned) * 100);
}

/** 1250 -> "12.50" (for form inputs). */
export function toMajorString(minor: number | null | undefined): string {
  if (minor === null || minor === undefined || Number.isNaN(minor)) return '';
  return (minor / 100).toFixed(2);
}

export function effectivePrice(price: number, salePrice: number | null | undefined): number {
  return salePrice !== null && salePrice !== undefined && salePrice < price ? salePrice : price;
}
